import type { TReferralApointment, TReferralAppointmentActions } from "./types";
import { HTTP } from "@/api";
import { createPathParamCRUD, type NoPathParams } from "@/api/shared/crud";
import type { DefaultPaginatedFilters } from "@/api/shared/filters";
import type { AxiosResponse } from "axios";
import { createService } from "@/api/shared/service";

export * from "./types";

const SLUG = "referral/appointment";
const SEARCH_SLUG = `${SLUG}/search`;

export default createService(SLUG, {
  ...createPathParamCRUD<TReferralApointment, NoPathParams, DefaultPaginatedFilters>(
    SLUG,
    SEARCH_SLUG
  ),

  async action(
    id: string,
    action: TReferralAppointmentActions
  ): Promise<AxiosResponse<TReferralApointment>> {
    return await HTTP.post<TReferralApointment>(`${SLUG}/${id}/${action}/`);
  },
});
